import { createContext, useContext, useState, useCallback } from "react";
import { markForceRefresh } from "../lib/api";

// Shared manual-refresh signal. A single top-bar button bumps `tick`; every cached screen adds
// `tick` to its data-loading effect so it re-fetches. During the refresh window the api layer
// appends ?refresh=1 so the server rebuilds (bypasses cache) rather than serving cached data.
const RefreshContext = createContext({ tick: 0, refreshing: false, lastRefreshedAt: Date.now(), refreshNow: () => {} });

export function RefreshProvider({ children }) {
  const [tick, setTick] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [lastRefreshedAt, setLastRefreshedAt] = useState(() => Date.now());

  const refreshNow = useCallback(() => {
    markForceRefresh(6000);      // window during which GETs carry ?refresh=1
    setRefreshing(true);
    setTick((t) => t + 1);       // re-trigger each screen's load effect
    setLastRefreshedAt(Date.now());
    setTimeout(() => setRefreshing(false), 1200);  // spinner feedback
  }, []);

  return (
    <RefreshContext.Provider value={{ tick, refreshing, lastRefreshedAt, refreshNow }}>
      {children}
    </RefreshContext.Provider>
  );
}

export const useRefresh = () => useContext(RefreshContext);
